import { api } from '@/core/helpers/axiosHelper';
import { Property } from './property.interface';

export default {
   async post(body: Property) {
      return await api.post('/property', body).then((response) => response);
   },
   async patch(property_id: number, body: Array<{ op: string; path: string; value: any }>) {
      return await api.patch(`/property/${property_id}`, body);
   },
   async delete(property_id: number) {
      return await api.delete(`/property/${property_id}`);
   },
};
